
import React, { useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import { VehicleContext } from "../../Context/VehicleContext";

const EnterVehicleInfoForm = () => {
    const initialValues = {
        year: "",
        make: "",
        model: "",
        mileage: "",
        email: "",
    };

    const { submitContactForm, uploadDocument } = useContext(VehicleContext);
        
    const recaptchaRef = React.useRef();

    // Validation schema
    const validationSchema = Yup.object({
        year: Yup.string().required("Year is required"),
        make: Yup.string().required("Make is required"),
        model: Yup.string().required("Model is required"),
        mileage: Yup.string().required("Mileage is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
    });

    return (
        <>


            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={async (values, { resetForm }) => {
                            
                    const token = await recaptchaRef.current.executeAsync();
                    recaptchaRef.current.reset(); // Reset after use
                    
                    values = { ...values, token: token };
                    console.log(values);

                    const data = await submitContactForm(values);

                    if (data.success) {
                        resetForm();
                        alert("Thank you for your submission. We'll be in touch soon!");
                    } else
                        alert("There was a problem with your submission");
                }}
            >
                {() => (
                    <Form className="custom-form wbe-form">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6LckXRIsAAAAAAiOe2UBkXy7Uy-ROdiueqrr4Lzk" // Replace with your actual site key
                            size="invisible"
                        /> 
                        <div className="form-group">
                            <Field
                                type="text"
                                name="year"
                                placeholder="Year"
                                className="form-control"
                            />
                            <ErrorMessage name="year" component="div" className="text-danger" />
                        </div>

                        <div className="form-group">
                            <Field
                                type="text"
                                name="make"
                                placeholder="Make"
                                className="form-control"
                            />
                            <ErrorMessage name="make" component="div" className="text-danger" />
                        </div>

                        <div className="form-group">
                            <Field
                                type="text"
                                name="model"
                                placeholder="Model"
                                className="form-control"
                            />
                            <ErrorMessage name="model" component="div" className="text-danger" />
                        </div>

                        <div className="form-group">
                            <Field
                                type="text"
                                name="mileage"
                                placeholder="Mileage"
                                className="form-control"
                            />
                            <ErrorMessage name="mileage" component="div" className="text-danger" />
                        </div>

                        <div className="form-group">
                            <Field
                                type="email"
                                name="email"
                                placeholder="Email"
                                className="form-control"
                            />
                            <ErrorMessage name="email" component="div" className="text-danger" />
                        </div>

                        <button
                            type="submit"
                            className="orange-white-btn w-100 fw-700 text-uppercase"
                        >
                            Get Offer
                        </button>
                    </Form>
                )}
            </Formik>

        </>
    )
}

export default EnterVehicleInfoForm